<ng-template #showGetPointModal let-modal>
    <div class="modal-body">
        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>
        
        <img src="assets/images/popuppuntos.png" style="width: 100%;">
    </div>
</ng-template>
